import {TabNavViewSwitch} from './tab-nav'
import type {ViewSwitchProps} from './types'

export const ViewSwitch = (props: ViewSwitchProps) => {
  return <TabNavViewSwitch {...props} />
}
